export default __webpack_public_path__ + "static/pilar-dalo-f3f0d1a3b0593cd93d0d701ef07dbc48.png";